module.exports = __webpack_public_path__ + "google_logo.4514f3f581f13f432db5a80fab50020b.png";